import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  redirectUrl: string;
  isLoggedIn = new BehaviorSubject<boolean>(false);

  // To mange user permissions and role
  private permissions: string[] = [];
  private role: string = '';

  constructor(private router: Router) {
    
  }
get isLogin():boolean{
  if (localStorage.getItem("user_id")) {
   return true;
  } else {
   return  false;

  }
}

  /**
   * To set user permissions and role after login
   * @param role - user role
   * @param permissions - user permissions
   */
  setAuthData(role: string, permissions: string[]) {
    this.role = role;
    this.permissions = permissions;
  }

  /**
   * To load user permissions and role from localStorage
   * @returns - void
   */
  loadAuthData() {
    this.role = localStorage.getItem('role') || '';
    this.permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  }

  /**
   * To check if current user has the specified permission
   * @param permission - permission to check
   * @returns - true if current user has the permission, false otherwise
   */
  hasPermission(permission: string | string[]): boolean {
    if (Array.isArray(permission)) {
      return permission.some(perm => this.permissions.includes(perm));
    }
    return this.permissions.includes(permission);
  }

  /**
   * To check if current user has the specified role
   * @param role - role to check
   * @returns - true if current user has the role, false otherwise
   */
  hasRole(role: string): boolean {
    return this.role === role;
  }

  /**
   * To get current user role
   * @returns current user role
   */
  getUserRole() {
    return this.role;
  }

  /**
   * To get current user permissions
   * @returns current user permissions
   */
  getUserPermissions() {
    return this.permissions;
  }
}

